var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "si:Info",
    clipPath: "url(#clip0_1138_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M7.00006 4.69315H7.00472M7.00006 9.16195V6.36895M12.5861 6.92755C12.5861 10.0126 10.0851 12.5136 7.00006 12.5136C3.915 12.5136 1.41406 10.0126 1.41406 6.92755C1.41406 3.84249 3.915 1.34155 7.00006 1.34155C10.0851 1.34155 12.5861 3.84249 12.5861 6.92755Z",
    stroke: "#121212",
    strokeOpacity: 0.5,
    strokeWidth: 0.8379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1138_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4064,
    height: 13.4064,
    fill: "white",
    transform: "translate(0.296875 0.224365)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoDark);
export default __webpack_public_path__ + "static/media/icon-info-dark.f70996d80c0d309ddb8fadbea09337d3.svg";
export { ForwardRef as ReactComponent };